<template>
  <v-row no-gutters :class="$vuetify.theme.dark?'grey-darken-3 pa-2 ':'white pa-2 '">

    <v-col cols="6" justify="start">
      <v-list-item>

        <v-list-item-content>
          <v-list-item-subtitle class="subtitle">
            {{ $language.jobDetails['Total Pay'] }}:
          </v-list-item-subtitle>
          <v-list-item-title class="headline font-weight-bold mb-1">
            $ {{totalSpend}}
          </v-list-item-title>
        </v-list-item-content>

      </v-list-item>
    </v-col>
    <v-col cols="6" v-if="job.rateType === 'Hourly'">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle">
            {{ $language.jobDetails['Total Hours'] }}:
          </v-list-item-subtitle>
          <v-list-item-title class="headline font-weight-bold mb-1">
            {{totalHours}}
          </v-list-item-title>
        </v-list-item-content>

      </v-list-item>
    </v-col>

    <v-col cols="12">
      <v-divider></v-divider>
    </v-col>

    <v-col cols="12">
      <div class="pa-4" v-if="paymentPending.length>0">
        <template v-for="(item, index) in paymentPending">
          <v-badge overlap right :key="index" color="amber darken-2" >
            <template v-slot:badge>
              <span>{{item.count}}</span>
            </template>
            <v-avatar size="40" @click="$emit('handle-pay-individual',item)">
              <img :src="item.avatar" alt="alt">
            </v-avatar>
          </v-badge>
        </template>
      </div>
      <v-list-item v-else class="pa-3">
        <v-list-item-content>
          <v-list-item-title class="title">
          </v-list-item-title>
          <v-list-item-subtitle class="subtitle">
           {{$language.jobDetails['No pending payments']}}
          </v-list-item-subtitle>
        </v-list-item-content>

      </v-list-item>
    </v-col>

    <v-col cols="12">
      <v-divider></v-divider>
    </v-col>
    <v-col cols="12">
      <v-list dense class="overflow-y-auto px-1" :height="$vuetify.breakpoint.width>1023?$vuetify.breakpoint.height-190:$vuetify.breakpoint.height-250">
        <template v-for="item in payouts.transactions">
          <payout-list-item :key="item._key" :transaction="item" :applicants="applicants"></payout-list-item>
        </template>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import PayoutListItem from '@/components/jefe/payouts/PayoutListItem'
// const fb = require('@/services/firebaseConfig.js')
export default {
  props: ['job', 'applicants', 'payouts', 'isHefe'],
  components: {
    PayoutListItem
  },
  data () {
    return {
      sub: '',
      buttonLoading: false

    }
  },

  computed: {
    ...mapState(['userProfile', 'currentUser']),
    totalSpend () {
      var val = Object.values((this.payouts || {}).transactions || {}).reduce((a, c) => {
        return parseFloat(c.paymentAmount) + parseFloat(a)
      }, 0)
      return (val).toFixed(2)
    },
    totalHours () {
      var shifts = Object.values((this.payouts || {}).transactions || {}).map(k => {
        return k.shifts
      }).flat().filter(k => {
        return k
      }).reduce((a, c) => {
        return a + c.secondsWorked
      }, 0)
      return (shifts / 3600).toFixed(2)
    },
    paymentPending () {
      var pending = Object.values(this.applicants || {}).map(k => {
        if (k.jobLog) {
          var count = Object.values(k.jobLog).reduce((a, c) => {
            if (c.status === 'pending') {
              a = a + 1
              return a
            }
            return a
          }, 0)
          k.count = count
          if (count) {
            return k
          }
        }
      }).filter(k => k !== undefined)
      return pending
    }
  },
  methods: {

  },
  watch: {
    payouts () {
    }
  },
  filters: {
    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(moment(`${this.job.startDate}T${val.h} ${val.mm} ${val.A}`, ['HH.mm a']).format('hh:mm a'))
      return moment(date).fromNow()
    },
    formatTime (val) {
      return moment(val).format('hh:mm:ss a')
    },
    formatHour (val) {
      if (!val) {
        return '-'
      }
      return val === parseInt(1) ? 'hour' : 'hours'
    },
    formatHoursWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 3600)
      return Math.round(val % 24)
    },
    formatMinWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 60)
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatSecWorked (val) {
      if (!val) {
        return '-'
      }
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    }
  }
}
</script>
